import script from "./UserTreeGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./UserTreeGroup.vue?vue&type=script&setup=true&lang=js"

import "./UserTreeGroup.vue?vue&type=style&index=0&id=f72bf4a2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f72bf4a2"]])

export default __exports__